
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  SaveManager,
  DelManager,
  GetManagerList,
  GetRoleList
} from '@/api/admin/permission'
import { GetToken } from '@/libs/util'
import InputSear from '@/views/components/InputSear.vue'
import countrycode from '@/common/countrycode'
import Clipboard from 'clipboard'
import md5 from 'js-md5'
@Component({
  components: { InputSear }
})
export default class account extends Vue {
  name = 'userAdmin_account'
  select = {
    user_list: [], //用户可管理app列表
    roleList: [],
    appid_list: [], //app列表
    countrycode: countrycode
  }
  tableMaxHeight = 0
  userInfo: any = {}
  appData = {
    show: false,
    platAll: '',
    data: [],
    columns: [
      {
        title: 'app信息',
        key: 'app_name',
        align: 'center'
      },
      {
        title: '所属平台',
        align: 'center',
        key: 'plat_name'
      },
      {
        title: '包网类型',
        key: 'http_name',
        align: 'center'
      }
    ]
  }
  platModel = {
    show: false,
    platCheck: 0,
    listLength: 0,
    checkAll: false,
    indeterminate: false,
    data: [],
    app_list: [],
    columns: [
      {
        title: 'app信息',
        key: 'appName',
        align: 'center'
      },
      {
        title: '所属平台',
        align: 'center',
        key: 'platform',
        render: (h, params) => {
          let item: any = this.getPlatItem(params.row.platform)
          return h('span', item ? item.name : '')
        }
      },
      {
        title: '包网类型',
        key: 'http_name',
        align: 'center',
        render: (h, params) => {
          let type = params.row.sale_type
          let arr = ['内部包网', '外部包网', '合作包网']
          return h('span', arr[type] || '')
        }
      },
      {
        title: '配置状态',
        align: 'center',
        key: 'appid',
        render: (h, params) => {
          return h(
            'Checkbox',
            {
              props: {
                label: params.row.appid
              }
            },
            ''
          )
        }
      }
    ]
  }
  table = {
    params: {
      user: '',
      role_id: 0,
      app_id: [],
      page: 1,
      limit: 10
    },
    google_code: '',
    data: [],
    columns: [
      {
        type: 'index',
        title: '序号',
        width: 50,
        align: 'center'
      },
      { title: 'ID', key: 'user_id', align: 'center', minWidth: 100 },
      { title: '用户名', key: 'username', align: 'center', minWidth: 100 },
      { title: '姓名', key: 'nickname', align: 'center', minWidth: 100 },
      { title: '权限ID', key: 'role_id', align: 'center', minWidth: 100 },
      {
        title: '权限角色',
        key: 'role_name',
        align: 'center',
        minWidth: 130,
        render: (h, params) => {
          let result: any = this.select.roleList.find(
            item => item['role_id'] == params.row.role_id
          )
          return h('div', result ? result.name : '')
        }
      },
      {
        title: '管理盘口',
        key: 'app_list',
        align: 'center',
        minWidth: 100,
        render: (h, params) =>
          h(
            'span',
            {
              style: {
                color: '#2d8cf0',
                textDecoration: 'underline',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.appData.show = true
                  let arr = params.row.app_list || this.getAllAppIdList()
                  this.appData.data = arr.reduce((res: any, cur: any) => {
                    let item: any = this.getAppItem(cur)
                    let typeNameList = ['内部包网', '外部包网', '合作包网']
                    let plat_name = ''
                    let http_name = ''
                    if (item) {
                      let plat = this.getPlatItem(item.platform)
                      plat_name = plat ? plat.name : ''
                      http_name = typeNameList[item.sale_type] || ''
                      res.push({
                        app_id: cur,
                        app_name: item ? item.appName : '',
                        plat_name,
                        http_name
                      })
                    }
                    return res
                  }, [])
                  this.appData.platAll = ''
                  this.appListModal.platid_list.map(item => {
                    if (params.row.app_list.includes(item.value)) {
                      this.appData.platAll += item.name + '、'
                    }
                  })
                }
              }
            },
            '查看详情'
          )
      },
      {
        title: 'IP白名单',
        key: 'ip_list',
        align: 'center',
        minWidth: 140,
        render: (h, params) => {
          let arr: any = params.row.ip_list.reduce((res: any, item: any) => {
            res.push(h('div', { style: { lineHeight: '25px' } }, item))
            return res
          }, [])
          return h('div', arr)
        }
      },
      {
        title: '状态',
        key: 'status',
        align: 'center',
        width: 130,
        filters: [
          { label: '活跃', value: 1 },
          { label: '禁用', value: 2 }
        ],
        filterMultiple: false,
        filterMethod(value, row) {
          if (value === 1) {
            return row.status === 1
          } else if (value === 2) {
            return row.status === 2
          }
        },
        render: (h, params) => {
          return h(
            'span',
            {
              style: {
                color: params.row.status == 1 ? 'blue' : 'red'
              }
            },
            params.row.status == 1 ? '启用' : '禁用'
          )
        }
      },
      {
        title: '登录安全配置',
        key: 'google_status',
        align: 'center',
        minWidth: 140,
        render: (h, params) => {
          let arr: any = []
          if (params.row.google_status == 2 && params.row.phone_status == 2) {
            arr.push(this.renderGoogleStatus(h, 'red', '无配置'))
          } else {
            if (params.row.google_status == 1) {
              arr.push(this.renderGoogleStatus(h, '#32CD32', '谷歌密码验证'))
            }
            if (params.row.phone_status == 1) {
              this.renderGoogleStatus(h, 'blue', '手机短信验证')
            }
          }
          return h('div', arr)
        }
      },
      {
        title: '创建时间',
        key: 'create_time',
        align: 'center',
        minWidth: 140
      },
      {
        title: '最后登录时间',
        key: 'last_login',
        sortable: true,
        align: 'center',
        minWidth: 140
      },
      {
        title: '最后登录IP',
        key: 'last_login_ip',
        align: 'center',
        minWidth: 140
      },
      {
        title: '操作',
        key: 'operate',
        align: 'center',
        width: 180,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '6px'
                },
                on: {
                  click: () => {
                    ;(this.$refs[this.modal.form.ref] as any).resetFields()
                    let { app_list, google_code, area_code } = params.row
                    // this.modal.form.cur_app_list = app_list
                    //     ? app_list.filter((el: any) =>!this.select.user_list.find((dl: any) => dl.appid == el))
                    //     : [];
                    this.modal.form.params = {
                      ...params.row,
                      is_top_user: 2
                    }
                    this.modal.form.params.ip_list = params.row.ip_list.join(
                      ','
                    )
                    this.modal.form.params.google_code = google_code
                      ? '******'
                      : ''
                    this.modal.form.params.password = '******'
                    this.modal.form.params.area_code = area_code
                      ? `+${area_code}`
                      : ''
                    delete this.modal.form.params['_index']
                    delete this.modal.form.params['_rowKey']
                    delete this.modal.form.params['last_login']
                    delete this.modal.form.params['last_login_ip']
                    this.modal.form.type = false
                    this.modal.show = true
                  }
                }
              },
              '编辑'
            ),
            h(
              'Button',
              {
                props: { type: 'warning', size: 'small' },
                style: { marginRight: '6px' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认删除',
                      content: '<p>是否确认删除此用户</p>',
                      onOk: () => this.delManager(params.row.user_id)
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ],
    total: 0,
    pageSizes: [10, 20, 30, 40]
  }
  modal = {
    show: false,
    form: {
      type: true, //1是新增 0是修改
      ref: 'modal_form',
      collapse: [1, 2, 3],
      cur_app_list: [],
      params: {
        status: 1,
        google_status: 2,
        phone_status: 2,
        role_name: '',
        region_list: [],
        app_list: [],
        is_top_user: 2,
        google_code: '',
        ip_list: '',
        code_phone: '',
        area_code: '',
        password: ''
      },
      rules: {
        role_id: [
          {
            required: true,
            message: '请选择用户权限',
            trigger: 'change',
            validator: (this as any).simpleVerify('请选择用户权限')
          }
        ],
        app_list: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || value.length == 0) {
                callback('请配置管理盘口配置')
              } else {
                callback()
              }
            }
          }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'change' }
        ],
        // username: [
        //     {
        //         required: true,
        //         message: "请输入6-12位英文和数字组合的用户名",
        //         trigger: "blur",
        //         min: 6,
        //         max: 12,
        //         validator: (rule, value, callback) => {
        //             let reg = new RegExp(
        //                 /^[a-zA-Z0-9][a-zA-Z0-9_]{5,11}$/
        //             );
        //             if (!reg.test(value) || !value) {
        //                 callback("请输入6~12位英文字母，或数字母组合");
        //             } else {
        //                 callback();
        //             }
        //         },
        //     },
        // ],
        password: [
          {
            required: true,
            trigger: 'blur',
            min: 6,
            max: 18,
            validator: (rule, value, callback) => {
              let reg = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9_]{5,17}$/)
              if (!this.modal.form.type) {
                if (!value || value === '******') {
                  callback()
                } else {
                  if (!reg.test(value) || !value) {
                    callback('请输入6~18位英文字母，数字，或数字字母组合')
                  } else {
                    callback()
                  }
                }
              } else {
                if (!reg.test(value) || !value) {
                  callback('请输入6~18位英文字母，数字，或数字字母组合')
                } else {
                  callback()
                }
              }
            }
          }
        ],
        password2: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback('请输入确认密码')
              } else if (this.modal.form.params['password'] != value) {
                callback('请输入相同密码')
              } else {
                callback()
              }
            }
          }
        ],
        nickname: [
          {
            required: true,
            message: '请输入使用人姓名',
            trigger: 'blur'
          }
        ],
        // email: [
        //     {   required: true,
        //         trigger: 'blur',
        //         validator: (rule, value, callback) => {
        //             let reg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
        //             if (!reg.test(value)||!value) {
        //                 callback('请填写有效邮箱')
        //             } else {
        //                 callback()
        //             }
        //         }
        //     },
        // ],
        google_code: [
          {
            required: true,
            message: '请输入绑定的密匙',
            trigger: 'blur'
          }
        ],
        code_phone: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.modal.form.params['area_code']) {
                callback('请填写有效的手机区号和号码')
              } else if (!value) {
                callback('请填写有效的手机号码')
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  }
  appListModal = {
    show: false,
    platid_list: <any>[],
    app_list: <any>[],
    all_list: <any>[], //选择绑定平台、盘口
    platid: [],
    appid: []
  }
  //多选平台盘口
  selectPlatAppModal = {
    show: false,
    testObj: {}
  }
  //暂存选择平台盘口
  sureSelectPlatAppModal() {
    let submitList: any = [] //选中的平台盘口
    let arr = Object.keys(this.selectPlatAppModal.testObj)
    arr.map(key => {
      if (
        this.selectPlatAppModal.testObj[key].checkAppList.length ==
        this.selectPlatAppModal.testObj[key].checkAllGroup.length
      ) {
        submitList.push(Number(key))
      }
      this.selectPlatAppModal.testObj[key].checkAllGroup.map(item => {
        let idList = item.split('(')
        let id = idList[1].substring(0, idList[1].length - 1)
        submitList.push(Number(id))
      })
    })
    this.modal.form.params.app_list = submitList
    this.selectPlatAppModal.show = false
  }
  openSelectPlatAppModal() {
    this.selectPlatAppModal.show = true
  }
  //选择单个盘口
  checkAllGroupChangeTestIn(data) {
    let group = ''
    for (let key in this.selectPlatAppModal.testObj) {
      let temp = this.selectPlatAppModal.testObj[key]
      if (temp['checkAllGroup'] == data) {
        group = key
        break
      }
    }
    if (
      data.length ===
      this.selectPlatAppModal.testObj[group]['checkAppList'].length
    ) {
      this.selectPlatAppModal.testObj[group]['indeterminate'] = false
      this.selectPlatAppModal.testObj[group]['checkAll'] = true
    } else if (data.length > 0) {
      this.selectPlatAppModal.testObj[group]['indeterminate'] = true
      this.selectPlatAppModal.testObj[group]['checkAll'] = false
    } else {
      this.selectPlatAppModal.testObj[group]['indeterminate'] = false
      this.selectPlatAppModal.testObj[group]['checkAll'] = false
    }
  }
  //每个平台全选
  handleCheckAllTestIn(outindex) {
    let obj = this.selectPlatAppModal.testObj
    if (obj[outindex].indeterminate) {
      obj[outindex].checkAll = false
    } else {
      obj[outindex].checkAll = !obj[outindex].checkAll
    }
    obj[outindex].indeterminate = false
    if (obj[outindex].checkAll) {
      obj[outindex].checkAllGroup = this.selectPlatAppModal.testObj[
        outindex
      ].checkAppList
    } else {
      obj[outindex].checkAllGroup = []
    }
  }

  getAllList() {
    let appData = (this as any).copyData(this.select.user_list)
    let platData = (this as any).copyData((this as any).plat_list)
    this.appListModal.app_list = []
    appData.map(item => {
      let obj = {
        value: item.appid,
        name: item.appName
      }
      this.appListModal.app_list.push(obj)
    })
    // this.appListModal.platid_list = [{value:0, name: '大平台'}]
    platData.map(item => {
      let obj = {
        value: item.id,
        name: item.name
      }
      this.appListModal.platid_list.push(obj)
    })
    this.appListModal.all_list = [
      ...this.appListModal.app_list,
      ...this.appListModal.platid_list
    ]
    //组多选平台盘口内容
    let testObj: any = {}
    platData.map(item1 => {
      let testArr: any = []
      let appArr: any = []
      appData.map(item2 => {
        if (item1.id == item2.platform) {
          let obj = {}
          obj = {
            id: item2.appid,
            name: item2.appName
          }
          testArr.push(item2.appName + '(' + item2.appid + ')')
          appArr.push(obj)
        }
      })
      testObj[item1.id] = testObj[item1.id] || {}
      testObj[item1.id]['appArr'] = appArr
      testObj[item1.id]['checkAppList'] = testArr
      testObj[item1.id]['indeterminate'] = false
      testObj[item1.id]['checkAll'] = false
      testObj[item1.id]['checkAllGroup'] = []
      testObj[item1.id]['plarName'] = item1.name
    })
    this.selectPlatAppModal.testObj = testObj
  }
  sureAppListModal() {
    this.modal.form.params.app_list = [
      ...this.appListModal.platid,
      ...this.appListModal.appid
    ]
    this.appListModal.show = false
  }
  changeAppListSelect() {
    // let arr = (this as any).copyData(this.modal.form.params.app_list)
    // let pl_list = (this as any).plat_list.map(el=> el.id);
    // pl_list.unshift(0);
    // pl_list = Array.from(new Set(pl_list));
    // let apparr2: any = []
    // let plarr: any = []
    // arr.map((item:any) => {
    //     if(pl_list.includes(item)){
    //         plarr.push(item)
    //     }else{
    //         apparr2.push(item)
    //     }
    //     this.appListModal.platid = plarr
    //     this.appListModal.appid = apparr2
    // })
    // this.appListModal.show = true
    // this.platModel.show = true;
    this.platModel.app_list = (this as any).copyData(
      this.modal.form.params.app_list
    )
    this.platModel.platCheck = 0

    let appData = (this as any).copyData(this.select.user_list)
    let arr = (this as any).copyData(this.modal.form.params.app_list)
    let pl_list = (this as any).plat_list.map(el => el.id)
    // pl_list.unshift(0);
    pl_list = Array.from(new Set(pl_list))
    let arrfind = arr.find(el => el == 0)
    if (arrfind == 0) {
      let keyArr = Object.keys(this.selectPlatAppModal.testObj)
      keyArr.map(key => {
        this.selectPlatAppModal.testObj[key].checkAll = true
        this.selectPlatAppModal.testObj[key].indeterminate = false
        this.selectPlatAppModal.testObj[
          key
        ].checkAllGroup = this.selectPlatAppModal.testObj[key].checkAppList
      })
    } else {
      arr.map((item: any) => {
        if (pl_list.includes(item)) {
          this.selectPlatAppModal.testObj[item].checkAll = true
          this.selectPlatAppModal.testObj[item].indeterminate = false
          this.selectPlatAppModal.testObj[
            item
          ].checkAllGroup = this.selectPlatAppModal.testObj[item].checkAppList
        } else {
          let platform = appData.find(el => el.appid == item).platform
          let find = this.selectPlatAppModal.testObj[platform].appArr.find(
            el => el.id == item
          )
          if (find) {
            if (
              !this.selectPlatAppModal.testObj[platform].checkAllGroup.includes(
                find.name + '(' + find.id + ')'
              )
            ) {
              this.selectPlatAppModal.testObj[platform].checkAllGroup.push(
                find.name + '(' + find.id + ')'
              )
              if (
                this.selectPlatAppModal.testObj[platform].checkAppList.length ==
                this.selectPlatAppModal.testObj[platform].checkAllGroup.length
              ) {
                this.selectPlatAppModal.testObj[platform].indeterminate = false
                this.selectPlatAppModal.testObj[platform].checkAll = true
              } else {
                this.selectPlatAppModal.testObj[platform].indeterminate = true
                this.selectPlatAppModal.testObj[platform].checkAll = false
              }
            }
          }
        }
      })
    }
    this.selectPlatAppModal.show = true
  }
  updateAppList() {
    this.modal.form.params.app_list = this.platModel.app_list
    this.closeAppList()
  }
  //获取权限列表
  getRoleList() {
    GetRoleList({}).then(res => {
      this.select.roleList = res._param.list
    })
  }
  //获取用户列表
  getManagerList(num?) {
    if (num) this.table.params.page = 1
    GetManagerList({ ...this.table.params }).then(res => {
      this.table.data = res._param.list || []
      this.table.total = res._param.total
      this.table.google_code = res._param.google_code
    })
  }
  //查询分条
  limitchange(limit) {
    this.table.params.page = 1
    this.table.params.limit = limit
    this.getManagerList()
  }
  //查询分页
  pagechange(page) {
    this.table.params.page = page
    this.getManagerList()
  }
  //appid获取app信息
  getAppItem(id) {
    let item: any = this.select.appid_list.find((el: any) => el.appid == id)
    return item
  }
  //platform获取分组信息
  getPlatItem(id: any) {
    let item: any = (this as any).plat_list.find((el: any) => el.id == id)
    return item
  }
  renderGoogleStatus(h, color, str) {
    return h('span', { style: { color: 'red' } }, str)
  }
  openModal() {
    this.modal.form.cur_app_list = []
    this.modal.form.params = {
      status: 1,
      google_status: 2,
      phone_status: 2,
      role_name: '',
      region_list: [],
      app_list: [],
      is_top_user: 2,
      google_code: '',
      ip_list: '',
      code_phone: '',
      area_code: '',
      password: ''
    }
    ;(this.$refs[this.modal.form.ref] as any).resetFields()
    this.modal.show = true
    this.modal.form.type = true
  }
  closeModal() {
    ;(this.$refs[this.modal.form.ref] as any).resetFields()
    this.appListModal.platid = []
    this.appListModal.appid = []
    let keyArr = Object.keys(this.selectPlatAppModal.testObj)
    keyArr.map(key => {
      this.selectPlatAppModal.testObj[key].checkAll = false
      this.selectPlatAppModal.testObj[key].indeterminate = false
      this.selectPlatAppModal.testObj[key].checkAllGroup = []
    })
    this.modal.show = false
  }
  //更新表单提交
  updata() {
    ;(this.$refs[this.modal.form.ref] as any).validate(valid => {
      if (valid) {
        this.saveManager()
      }
    })
  }
  //更新信息
  saveManager() {
    // if (this.modal.form.type) {
    //   this.modal.form.params['password'] = md5(
    //     this.modal.form.params['password']
    //   )
    // } else {
    //   if (
    //     this.modal.form.params['password'] === '******' ||
    //     !this.modal.form.params['password']
    //   ) {
    //     this.modal.form.params['password'] = ''
    //   } else {
    //     this.modal.form.params['password'] = md5(
    //       this.modal.form.params['password']
    //     )
    //   }
    // }
    let password;

    if (this.modal.form.type) {
      password = md5(
        this.modal.form.params['password']
      )
    } else {
      if (
        this.modal.form.params['password'] === '******' ||
        !this.modal.form.params['password']
      ) {
        password = ''
      } else {
        password = md5(
          this.modal.form.params['password']
        )
      }
    }

    let params = { ...this.modal.form.params, password }
    let arr: any = []
    // params.app_list = [...this.modal.form.cur_app_list, ...params.app_list];
    params.ip_list = (params.ip_list as any).split(',').filter(v => v)
    params.area_code = params.area_code.replace('+', '')
    if (params.google_status == 2) {
      params.google_code = ''
    } else {
      if (params.google_code === '******') {
        params.google_code = ''
      } else {
        params.google_code = params.google_code
      }
    }
    SaveManager(params).then(res => {
      this.$Message.success('配置成功')
      this.getManagerList(1)
      this.closeModal()
      if (res['_param'].data) {
        this.$Modal.info({
          title: '谷歌验证码信息',
          content: '登录谷歌验证码密匙：' + res['_param'].data
        })
      }
    })
  }
  //删除用户
  delManager(user_id) {
    DelManager({ user_id }).then(res => {
      this.$Message.success('删除成功')
      this.getManagerList()
    })
  }
  getUserInfo() {
    let userInfo = GetToken()
    GetManagerList({
      user: `${userInfo.uid}`,
      role_id: userInfo.role_id,
      page: 1,
      limit: 10
    }).then(res => {
      try {
        this.userInfo = res._param.list[0] || {}
      } catch (error) {}
    })
  }

  updatePlatCheck(val) {
    this.platModel.platCheck = val
    this.updateTableModelCheck()
  }
  @Watch('platModel.app_list')
  updateTableModelCheck() {
    let val: any = this.platModel.app_list
    let realCount = 0
    let arr = this.select.user_list.filter((el: any) => {
      if (val.includes(el.appid) && el.platform == this.platModel.platCheck)
        realCount++
      return (
        this.platModel.platCheck == 0 ||
        val.includes(el.appid) ||
        el.platform == this.platModel.platCheck
      )
    })
    let len = arr.length
    if (val.length == 0) {
      this.platModel.indeterminate = false
      this.platModel.checkAll = false
    } else if (val.length == len) {
      this.platModel.indeterminate = false
      this.platModel.checkAll = true
    } else {
      this.platModel.indeterminate = realCount > 0
      this.platModel.checkAll = false
    }
  }
  @Watch('modal.form.params.app_list')
  updateCheckList() {
    if (this.modal.form.params.app_list == null) {
      this.modal.form.params.app_list = this.getAllAppIdList()
      this.platModel.app_list = (this as any).copyData(
        this.modal.form.params.app_list
      )
    }
  }
  getAllAppIdList(): any {
    return this.select.appid_list.map((el: any) => el.appid)
  }
  handleCheckAll(val) {
    this.platModel.checkAll = this.platModel.indeterminate
      ? false
      : !this.platModel.checkAll
    if (this.platModel.indeterminate) this.platModel.indeterminate = false
    if (this.platModel.checkAll) {
      if (this.platModel.platCheck == 0) {
        let list: any = Array.from(
          new Set([
            ...this.platModel.app_list,
            ...this.select.user_list.reduce((res: any, cur: any) => {
              res.push(cur.appid)
              return res
            }, [])
          ])
        )
        this.platModel.app_list = list
      } else {
        let otherArr: any = this.select.user_list
          .filter((el: any) => {
            return (
              el.platform == this.platModel.platCheck &&
              !(this.platModel.app_list as any).includes(el.appid)
            )
          })
          .reduce((res: any, cur: any) => {
            res.push(cur.appid)
            return res
          }, [])
        ;(this.platModel.app_list as any) = [
          ...this.platModel.app_list,
          ...otherArr
        ]
      }
    } else {
      this.platModel.app_list = []
    }
  }
  rowClassName(row) {
    if (
      this.platModel.platCheck != 0 &&
      row.platform != this.platModel.platCheck
    ) {
      return 'hidden-table'
    } else {
      return ''
    }
  }

  closeAppList() {
    this.platModel.show = false
  }
  initFunc() {
    this.select.appid_list = (this as any).plat_list.reduce(
      (res: any, cur: any) => {
        let platSortArr = (this as any).app_list.filter(
          (el: any) => el.platform == cur.id
        )
        res = [...res, ...platSortArr]
        return res
      },
      []
    )
    this.select.user_list = this.select.appid_list
    this.getUserInfo()
    this.getAllList()
  }
  copyText1() {
    let clipboard = new Clipboard('#copyText1')
    clipboard.on('success', e => {
      this.$Message.success('复制成功')
      // 释放内存
      clipboard.destroy()
    })
    clipboard.on('error', e => {
      this.$Message.error('复制失败，请手动复制')
      // 不支持复制
      // 释放内存
      clipboard.destroy()
    })
    this.modal.form.params.google_code =
      this.modal.form.params.google_status == 1 ? this.table.google_code : ''
  }
  changeCode1(value) {
    if (value == 2) {
      this.modal.form.params.google_code = ''
    } else {
      if (this.modal.form.type) {
        this.modal.form.params.google_code = this.table.google_code
      } else {
        this.modal.form.params.google_code = ''
      }
    }
  }
  created() {
    this.initFunc()
    this.getManagerList()
    this.getRoleList()
  }
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 200
  }
}
